import credit from '@/api/default-credit-day'

export const state = {
  edit_data: {},
  resources: []
}

export const getters = {}

export const mutations = {
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  RECEIVE_RESOURCES(state, data) {
    state.resources = []
    data.forEach(resource => {
      state.resources.push(Object.assign(resource, { _deleting: false }))
    })
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    return credit.get().then(response => {
      context.commit('RECEIVE_RESOURCES', response.data)
      return Promise.resolve(response)
    })
  },
  update(context, data) {
    return credit.update(data)
  }
}
